module.exports = __webpack_public_path__ + "img/downtips.843db1a5.png";